// Registry: nơi đăng ký tất cả loại thẻ. Thêm loại thẻ mới = thêm 1 dòng ở đây.
import type { Card, CardType } from '../types/LessonDoc'
import type { CardDef } from './types'

import { textCardDef } from './TextCard'
import { richTextCardDef } from './RichTextCard'
import { richCardDef } from './RichCard'
import { htmlCardDef } from './HtmlCard'
import { wordCardDef } from './WordCard'
import { videoCardDef } from './VideoCard'
import { infographicCardDef } from './InfographicCard'
import { simulationCardDef } from './SimulationCard'
import { pdfCardDef } from './PdfCard'
import { pptxCardDef } from './PptxCard'
import { quizCardDef } from './QuizCard'
import { gameCardDef } from './GameCard'
import { liveSessionCardDef } from './LiveSessionCard'
import { labCardDef } from './LabCard'
import { englishCardDef } from './EnglishCard'

// Thứ tự hiển thị trên bảng chọn thẻ.
// KHÔNG gồm 'rich' (chỉ tạo qua kế thừa) và 'text' (đã GỘP vào thẻ 'richtext' "Văn bản";
// vẫn giữ định nghĩa trong ALL_DEFS để bài cũ có thẻ 'text' render/sửa được).
export const CARD_DEFS: CardDef[] = [
  richTextCardDef,
  htmlCardDef,
  wordCardDef,
  videoCardDef,
  infographicCardDef,
  simulationCardDef,
  pdfCardDef,
  pptxCardDef,
  quizCardDef,
  labCardDef,
  englishCardDef,
  gameCardDef,
  liveSessionCardDef,
]

// Tất cả định nghĩa (gồm 'rich' và 'text' kế thừa) — dùng để tra cứu khi render/sửa.
const ALL_DEFS: CardDef[] = [...CARD_DEFS, richCardDef, textCardDef]

const CARD_MAP: Record<CardType, CardDef> = ALL_DEFS.reduce(
  (acc, def) => {
    acc[def.type] = def
    return acc
  },
  {} as Record<CardType, CardDef>
)

export function getCardDef(type: CardType): CardDef {
  return CARD_MAP[type]
}

export function createDefaultCard(type: CardType): Card {
  return CARD_MAP[type].createDefault()
}
